import { faker } from '@faker-js/faker';

import type { DipPostResponse } from '../types/DipPostResponse';

export function createDipPostResponse(data: NonNullable<Partial<DipPostResponse>> = {}): NonNullable<DipPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
